<template>
  <ParamForm :module="module"/>
</template>
<script>
import ParamForm from "@/views/modules/general/ParamForm";
import pageParamMixin from "@/mixins/page/pageParamMixin";

export default {
  name: 'SettingParam',
  mixins: [pageParamMixin],
  components: {ParamForm},
  data() {
    return {
      module: "admin",
    }
  },
}
</script>